<template>
  <DialogFull :data="dialogSettings" @close="close">
    <div class="container col-lg-8 col-sm-12">
      <Qualification @close="close" submitButtonTitle="Save Changes" />
    </div>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import Qualification from "@/views/profile/QuestionsAndAnswers/steps/Qualifications/Qualifications";

export default {
  components: {
    DialogFull,
    Qualification
  },
  props: {
    isOpen: Boolean
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Qualifications"
      };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
